import { MONTH_OPTIONS } from "."

export const columns = [
  {
    id: 'year',
    label: 'Year',
    width: '120px',
    isFormatted: false
  },
  {
    id: 'month',
    label: 'Month',
    width: '150px',
    type: 'dropdown', 
    options: MONTH_OPTIONS
  },
  {
    id: 'tdsSection',
    label: 'TDS section',
    width: '150px',
  },
  {
    id: 'finalTdsSectionCode',
    label: 'TDS Section Code',
    width: '170px',
    isFormatted: false
  },
  {
    id: 'vendorStatus',
    label: ' Corporate/Non-Corporate',
    width: '150px',
  },
  {
    id: 'grossExpenseAmount',
    label: 'Gross expense amount',
    width: '250px',
  },
  {
    id: 'tdsBaseAmount',
    label: 'TDS base amount',
    width: '250px',
  },
  {
    id: 'tdsAmount',
    label: 'TDS amount',
    width: '120px',
  },
  {
    id: 'surcharge',
    label: 'Surcharge',
    width: '120px',
  },
  {
    id: 'eductionCess',
    label: 'Education cess',
    width: '200px',
  },
  {
    id: 'totalTdsLiability',
    label: 'Total tds liability',
    width: '250px',
  },
  {
    id: 'interestOnLateDeduction',
    label: 'Interest on late deduction',
    width: '220px',
  },
  {
    id: 'interestOnLateDeposit',
    label: 'Interest on late deposit',
    width: '220px',
  }
]


export const searchFields = [...columns.map(col => {
  return {
    ...col,
    type: col.type || 'text',
    placeholder: `Enter ${col.label}`,
  }
})]